const MoneyMgmtTestDataset = {currentVersion: 1.0, topicList: [
    /*
        Budgeting & Saving → very practical → double
        Financial Decision-Making → critical thinking about choices → double
        Credit & Debt → often tricky for students → double
    */

  {topic: "Budgeting & Saving", questionList: [
    {
      "questionNbr": "BD-01",
      "questionText": "Which of these is considered good financial literacy advice?",
      "answerType": "multiple",
      "notes": "Encourages tracking income and saving regularly.",
      "answerList": [
        { "answer": "a", "label": "The best investments are risky because they offer the highest return.", "correct": false, "checked": false },
        { "answer": "b", "label": "You can spend as much as you want each month as long as you don’t spend more than what you make.", "correct": false, "checked": false },
        { "answer": "d", "label": "If possible, save some money each month.", "correct": true, "checked": false },
        { "answer": "e", "label": "It is a good idea to know how much money you have each month to buy things that you might want.", "correct": true, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-02",
      "questionText": "What is the best advice about saving money?",
      "answerType": "single",
      "notes": "Reinforces starting early and consistent saving.",
      "answerList": [
        { "answer": "a", "label": "Saving money is not really that important. As long as you make enough to cover monthly expenses, all is well.", "correct": false, "checked": false },
        { "answer": "b", "label": "Saving is the most important thing. Even if you can't pay off your credit card in a given month, you should still stick to your monthly savings amount.", "correct": false, "checked": false },
        { "answer": "c", "label": "Start saving money when you are within 10 years of retirement so you will have money for fun items when you are young.", "correct": false, "checked": false },
        { "answer": "d", "label": "Start saving early, but balance saving with paying necessary expenses and avoiding high-interest debt.", "correct": true, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-03",
      "questionText": "Why is it a good idea to create a monthly budget?",
      "answerType": "multiple",
      "notes": "Overlaps with other budgeting questions; keep for randomization pool.",
      "answerList": [
        { "answer": "a", "label": "It helps you identify items that you can change to improve your money status.", "correct": true, "checked": false },
        { "answer": "b", "label": "You will have a good idea of how much money you can spend each month on extra (non-mandatory) items.", "correct": true, "checked": false },
        { "answer": "c", "label": "It increases your salary.", "correct": false, "checked": false },
        { "answer": "d", "label": "Having a monthly budget will impress your family and friends.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-04",
      "questionText": "If you have $100 left after paying all your essential expenses this month, what is the best choice for that money?",
      "answerType": "single",
      "notes": "Revised to assess needs vs wants and saving priorities.",
      "answerList": [
        { "answer": "a", "label": "If you do not already have a fully funded emergency fund, add it to your emergency savings fund.", "correct": true, "checked": false },
        { "answer": "b", "label": "Buy new clothes for work.", "correct": false, "checked": false },
        { "answer": "c", "label": "Go out for entertainment.", "correct": false, "checked": false },
        { "answer": "d", "label": "Buy a video game or concert ticket.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-05",
      "questionText": "Which one of the following is considered to be a fixed expense?",
      "answerType": "single",
      "notes": "Good item testing understanding of fixed vs variable costs.",
      "answerList": [
        { "answer": "a", "label": "Car loan payment.", "correct": true, "checked": false },
        { "answer": "b", "label": "Food at a grocery store.", "correct": false, "checked": false },
        { "answer": "c", "label": "Cost of heating and electricity.", "correct": false, "checked": false },
        { "answer": "d", "label": "Clothes for your job.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-06",
      "questionText": "Which of the following are part of a monthly budget?",
      "answerType": "multiple",
      "notes": "Reinforces same concept as BD-01 and BD-03; keep for rotation.",
      "answerList": [
        { "answer": "a", "label": "Salary amount.", "correct": true, "checked": false },
        { "answer": "b", "label": "Loan payment amounts.", "correct": true, "checked": false },
        { "answer": "c", "label": "Irregular expenses like annual insurance premiums (monthly average).", "correct": true, "checked": false },
        { "answer": "d", "label": "Paying an unexpected medical bill.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-07",
      "questionText": "You want to buy a $600 laptop in six months. If you save the same " +
          "amount each month, about how much should you plan to save monthly?",
      "answerType": "single",
      "notes": "Tests budgeting with simple division and forward planning.",
      "answerList": [
        { "answer": "a", "label": "$50", "correct": true, "checked": false },
        { "answer": "b", "label": "$75", "correct": false, "checked": false },
        { "answer": "c", "label": "$100", "correct": false, "checked": false },
        { "answer": "d", "label": "$150", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-08",
      "questionText": "If your income goes up but your spending increases just as much, what " +
        "happens to your savings?",
      "answerType": "single",
      "notes": "Encourages understanding of savings behavior, not just income level.",
      "answerList": [
        { "answer": "a", "label": "Your savings stay about the same.", "correct": true, "checked": false },
        { "answer": "b", "label": "Your savings increase automatically.", "correct": false, "checked": false },
        { "answer": "c", "label": "Your savings double because your income increased.", "correct": false, "checked": false },
        { "answer": "d", "label": "Your savings disappear completely.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-09",
      "questionText": "Which statement best describes how a checking account works?",
      "answerType": "single",
      "answerList": [
        { "answer": "a", "label": "It’s mainly used for long-term savings and earns a high interest rate.", "correct": false, "checked": false },
        { "answer": "b", "label": "It allows you to deposit money, pay bills, and make purchases using checks or a debit card.", "correct": true, "checked": false },
        { "answer": "c", "label": "It prevents you from ever spending more money than you have.", "correct": false, "checked": false },
        { "answer": "d", "label": "It can only be used for online purchases.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-10",
      "questionText": "Which of the following can cause overdraft fees on a checking account?",
      "answerType": "single",
      "answerList": [
        { "answer": "a", "label": "Depositing money into your account.", "correct": false, "checked": false },
        { "answer": "b", "label": "Spending more money than you have available in your account.", "correct": true, "checked": false },
        { "answer": "c", "label": "Paying a bill before its due date.", "correct": false, "checked": false },
        { "answer": "d", "label": "Using direct deposit for your paycheck.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "BD-11",
      "questionText": "What’s the key difference between a debit card and a credit card?",
      "answerType": "multiple",
      "answerList": [
        { "answer": "a", "label": "Debit cards pull money directly from your bank account.", "correct": true, "checked": false },
        { "answer": "b", "label": "Credit cards borrow money that must be repaid later.", "correct": true, "checked": false },
        { "answer": "c", "label": "Debit cards automatically improve your credit score.", "correct": false, "checked": false },
        { "answer": "d", "label": "Credit cards cannot be used for online purchases.", "correct": false, "checked": false }
      ]
    }

  ],
},
{
  topic: "Credit & Debt", questionList: [
    {
      "questionNbr": "CD-01",
      "questionText": "What is the best way to manage your credit card?",
      "answerType": "single",
      "notes": "Tests credit management and responsible payment behavior.",
      "answerList": [
        { "answer": "a", "label": "At the end of the month, pay what you can as long as it is more than the minimum payment amount.", "correct": false, "checked": false },
        { "answer": "b", "label": "It is best if you just pay the minimum payment each month.", "correct": false, "checked": false },
        { "answer": "c", "label": "You should never get a credit card.", "correct": false, "checked": false },
        { "answer": "d", "label": "Pay off the entire balance each month.", "correct": true, "checked": false }
      ]
    },
    {
      "questionNbr": "CD-02",
      "questionText": "Which of the following affect the amount of the monthly loan payment?",
      "answerType": "multiple",
      "notes": "Covers interest rate, loan term, and principal — key cost factors.",
      "answerList": [
        { "answer": "a", "label": "The interest rate that is charged on the loan.", 
          "correct": true, "checked": false },
        { "answer": "b", "label": "The amount of time that you have to pay back the loan (loan term).", 
          "correct": true, "checked": false },
        { "answer": "c", "label": "The total amount of the loan.", "correct": true, "checked": false },
        { "answer": "d", "label": "The amount of money (salary) that the borrower makes each month.", 
          "correct": false, "checked": false }
      ]
    },
      {
      "questionNbr": "CD-03",
      "questionText": "What is the benefit of maintaining a good credit score?",
      "answerType": "multiple",
      "answerList": [
        { "checked": false, "answer": "a", "correct": true, "label": "Lower interest rates on loans " +
          "and credit cards" },
        { "checked": false, "answer": "b", "correct": true, "label": "Better chances of getting "+ 
          "approved for housing or loans" },
        { "checked": false, "answer": "c", "correct": false, "label": "Lower insurance premiums in some cases." },
        { "checked": false, "answer": "d", "correct": false, "label": "It guarantees you will " + 
          "never go into debt" }
      ]
    },
    {
      "questionNbr": "CD-04",
      "questionText": "Which of the following are ways to responsibly manage debt?",
      "answerType": "multiple",
      "answerList": [
        { "checked": false, "answer": "a", "correct": true, "label": "Make at least the minimum payment " +
          "on time" },
        { "checked": false, "answer": "b", "correct": true, "label": "Avoid taking on more debt than " +
          "you can handle" },
        { "checked": false, "answer": "c", "correct": false, "label": "Pay only when the debt is overdue" },
        { "checked": false, "answer": "d", "correct": false, "label": "Borrow as much as possible to " + 
          "maximize rewards" }
      ]
    },
    {
      "questionNbr": "CD-05",
      "questionText": "If you only make the minimum payment on your credit card each month, " + 
        "what will happen over time?",
      "answerType": "multiple",
      "notes": "Tests long-term impact of minimum payments on debt and interest.",
      "answerList": [
        { "answer": "a", "label": "You will pay more in interest overall.", 
          "correct": true, "checked": false },
        { "answer": "b", "label": "It will take longer to pay off the balance.", 
          "correct": true, "checked": false },
        { "answer": "c", "label": "Your total debt will go down faster.", 
          "correct": false, "checked": false },
        { "answer": "d", "label": "Your credit score will automatically go up.", 
          "correct": false, "checked": false }
      ]
      },
      {
        "questionNbr": "CD-06",
        "questionText": "Which of the following situations could hurt your credit score the most?",
        "answerType": "single",
        "notes": "Tests awareness of credit score behaviors.",
        "answerList": [
          { "answer": "a", "label": "Missing several credit card payments.", "correct": true,
             "checked": false },
          { "answer": "b", "label": "Paying your full balance on time.", "correct": false, "checked": false },
          { "answer": "c", "label": "Having a low credit limit.", "correct": false, "checked": false },
          { "answer": "d", "label": "Checking your own credit score.", "correct": false, "checked": false }
        ]
      }

  ]
},
{topic: "Career & Income Planning", questionList: [
    {
      "questionNbr": "CI-01",
      "questionText": "Which of the following is something you really should consider when choosing a career?",
      "answerType": "multiple",
      "notes": "Adds earning potential and job fit — new PFL topic.",
      "answerList": [
        { "answer": "a", "label": "The education requirements for the job.", "correct": true, "checked": false },
        { "answer": "b", "label": "Whether or not the job seems to match your skills and interests.", "correct": true, "checked": false },
        { "answer": "c", "label": "The salary that you would make.", "correct": true, "checked": false },
        { "answer": "d", "label": "Your friends think the job sounds cool.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "CI-02",
      "questionText": "Which factors can influence your earning potential over a lifetime?",
      "answerType": "multiple",
      "answerList": [
          { "checked": false, "answer": "a", "correct": true, "label": "Level of education or training" },
          { "checked": false, "answer": "b", "correct": true, "label": "Experience and skills" },
          { "checked": false, "answer": "c", "correct": true, "label": "Industry and job demand" },
          { "checked": false, "answer": "d", "correct": false, "label": "Favorite color" }
      ]
    },
    {
      "questionNbr": "CI-03",
      "questionText": "You’re offered two jobs: one pays $18/hour with no benefits, the other pays $16/hour but includes health insurance. What should you consider most before deciding?",
      "answerType": "multiple",
      "notes": "Encourages understanding of total compensation vs. hourly wage.",
      "answerList": [
        { "answer": "a", "label": "The value of the health benefits and overall financial package.", 
          "correct": true, "checked": false },
        { "answer": "b", "label": "Nothing matters but the hourly wage.", "correct": false, "checked": false },
        { "answer": "c", "label": "Which job has more overtime hours.", "correct": false, "checked": false },
        { "answer": "d", "label": "Which job offers more paid time off.", "correct": true, "checked": false }
      ]
    },
    {
      "questionNbr": "CI-04",
      "questionText": "What is one smart way to reduce the amount you need to borrow for college or training?",
      "answerType": "multiple",
      "answerList": [
        { "answer": "a", "label": "Apply for scholarships and grants.", "correct": true, "checked": false },
        { "answer": "b", "label": "Work part-time while attending school.", "correct": true, "checked": false },
        { "answer": "c", "label": "Always choose the most expensive school to ensure better pay later.", "correct": false, "checked": false },
        { "answer": "d", "label": "Ignore financial aid and just use credit cards to pay tuition.", "correct": false, "checked": false }
      ]
    },
  {
    "questionNbr": "CI-05",
    "questionText": "Which statement about student loans is true?",
    "answerType": "single",
    "answerList": [
      { "answer": "a", "label": "You don’t have to pay back student loans if you graduate.", "correct": false, "checked": false },
      { "answer": "b", "label": "Student loans must be repaid, often with interest, after you leave school.", "correct": true, "checked": false },
      { "answer": "c", "label": "Student loans are free money that never affects your credit score.", "correct": false, "checked": false },
      { "answer": "d", "label": "Student loans are only available for four-year universities.", "correct": false, "checked": false }
    ]
  },
  {
    "questionNbr": "CI-06",
    "questionText": "Before taking out a student loan, what should you consider most carefully?",
    "answerType": "multiple",
    "answerList": [
      { "answer": "a", "label": "How much you’ll likely earn in your career after graduation.", "correct": true, "checked": false },
      { "answer": "b", "label": "The total amount you’ll need to repay, including interest.", "correct": true, "checked": false },
      { "answer": "c", "label": "Whether you like the school’s sports teams.", "correct": false, "checked": false },
      { "answer": "d", "label": "How quickly you can spend the borrowed money.", "correct": false, "checked": false }
    ]
  },
  {
  "questionNbr": "CI-07",
  "questionText": "Which of these best explains the difference between gross pay and net pay?",
  "answerType": "single",
  "answerList": [
    { "answer": "a", "label": "Gross pay is your total pay before taxes and deductions; net pay is what you actually take home.", "correct": true, "checked": false },
    { "answer": "b", "label": "Net pay is always higher than gross pay.", "correct": false, "checked": false },
    { "answer": "c", "label": "Gross pay includes only bonuses.", "correct": false, "checked": false },
    { "answer": "d", "label": "There is no difference; both are the same thing.", "correct": false, "checked": false }
  ]
    },
    {
      "questionNbr": "CI-08",
      "questionText": "Why is it important to understand how taxes affect your paycheck?",
      "answerType": "multiple",
      "answerList": [
        { "answer": "a", "label": "It helps you plan a budget based on your actual take-home pay.", "correct": true, "checked": false },
        { "answer": "b", "label": "It helps you know how much to withhold so you don’t owe a large amount later.", "correct": true, "checked": false },
        { "answer": "c", "label": "It ensures your employer won’t charge you for benefits.", "correct": false, "checked": false },
        { "answer": "d", "label": "It guarantees a tax refund every year.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "CI-09",
      "questionText": "What are common payroll deductions that reduce your gross income?",
      "answerType": "multiple",
      "answerList": [
        { "answer": "a", "label": "Federal and state income taxes.", "correct": true, "checked": false },
        { "answer": "b", "label": "Social Security and Medicare contributions.", "correct": true, "checked": false },
        { "answer": "c", "label": "Lunch expenses and parking tickets.", "correct": false, "checked": false },
        { "answer": "d", "label": "Tips you earn from customers.", "correct": false, "checked": false }
      ]
    }
  ]
},
{topic: "Investing & Wealth Building", questionList: [

  {
    "questionNbr": "IW-01",
    "questionText": "What is the primary purpose of a 401(k) savings account?",
    "answerType": "single",
    "notes": "Tests understanding of retirement and long-term savings.",
    "answerList": [
      { "answer": "a", "label": "To save for retirement.", "correct": true, "checked": false },
      { "answer": "b", "label": "To invest in the stock market.", "correct": false, "checked": false },
      { "answer": "c", "label": "To save for a down payment on a house.", "correct": false, "checked": false },
      { "answer": "d", "label": "To have an emergency fund for unexpected expenses.", "correct": false, "checked": false }
    ]
  },

  {
    "questionNbr": "IW-02",
    "questionText": "Why is diversification important when investing?",
    "answerType": "multiple",
    "notes": "Assesses understanding of investment risk management.",
    "answerList": [
      { "checked": false, "answer": "a", "correct": true, "label": "It reduces the risk of losing all your money in one investment." },
      { "checked": false, "answer": "b", "correct": true, "label": "It increases the potential for steady returns over time." },
      { "checked": false, "answer": "c", "correct": false, "label": "It guarantees the highest possible return." },
      { "checked": false, "answer": "d", "correct": false, "label": "It allows you to avoid paying taxes." }
    ]
  },

  {
    "questionNbr": "IW-03",
    "questionText": "How does compound interest help build wealth over time?",
    "answerType": "single",
    "notes": "Tests understanding of compounding effects.",
    "answerList": [
      { "checked": false, "answer": "a", "correct": true, "label": "It allows you to earn interest on both your initial savings and the interest that has already been added." },
      { "checked": false, "answer": "b", "correct": false, "label": "It guarantees that your investment will double every year." },
      { "checked": false, "answer": "c", "correct": false, "label": "It only applies to checking accounts." },
      { "checked": false, "answer": "d", "correct": false, "label": "It helps reduce taxes on investment income." }
    ]
  },

  {
    "questionNbr": "IW-04",
    "questionText": "Which statement best explains the relationship between risk and return in investing?",
    "answerType": "single",
    "notes": "Tests conceptual understanding of investment trade-offs.",
    "answerList": [
      { "checked": false, "answer": "a", "correct": true, "label": "Investments with higher potential returns usually come with higher risk." },
      { "checked": false, "answer": "b", "correct": false, "label": "Low-risk investments always produce the highest returns." },
      { "checked": false, "answer": "c", "correct": false, "label": "Risk and return are not related." },
      { "checked": false, "answer": "d", "correct": false, "label": "High-risk investments are guaranteed to earn more money." }
    ]
  },

  {
    "questionNbr": "IW-05",
    "questionText": "Why is starting to invest early generally a good financial strategy?",
    "answerType": "multiple",
    "notes": "Reinforces time value of money concepts.",
    "answerList": [
      { "checked": false, "answer": "a", "correct": true, "label": "Your money has more time to grow through compound interest." },
      { "checked": false, "answer": "b", "correct": true, "label": "You can recover more easily from market ups and downs over time." },
      { "checked": false, "answer": "c", "correct": false, "label": "You’ll automatically make more money than someone who starts later." },
      { "checked": false, "answer": "d", "correct": false, "label": "It eliminates all investing risk." }
    ]
  },

  {
    "questionNbr": "IW-06",
    "questionText": "Which factor should you consider before choosing an investment?",
    "answerType": "multiple",
    "notes": "Applies real-world reasoning to investment selection.",
    "answerList": [
      { "checked": false, "answer": "a", "correct": true, "label": "Your personal risk tolerance and financial goals." },
      { "checked": false, "answer": "b", "correct": true, "label": "How long you can keep the money invested (your time horizon)." },
      { "checked": false, "answer": "c", "correct": false, "label": "Which investment has been trending on social media." },
      { "checked": false, "answer": "d", "correct": false, "label": "The one with the highest short-term return, regardless of risk." }
    ]
  },
  {
      "questionNbr": "IW-07",
      "questionText": "If an investment promises a guaranteed 20% return in one month, what is the " + 
        "smartest response?",
      "answerType": "single",
      "notes": "Tests risk awareness and fraud recognition.",
      "answerList": [
        { "answer": "a", "label": "Be cautious—it’s likely too good to be true.", 
          "correct": true, "checked": false },
        { "answer": "b", "label": "Invest right away to maximize your return.", 
          "correct": false, "checked": false },
        { "answer": "c", "label": "Tell your friends to invest too.", "correct": false, "checked": false },
        { "answer": "d", "label": "Assume it’s safe because of the guaranteed return.", 
          "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "IW-08",
      "questionText": "Which of the following best explains how inflation affects your savings?",
      "answerType": "single",
      "notes": "Adds economic literacy link between inflation and purchasing power.",
      "answerList": [
        { "answer": "a", "label": "It reduces what your money can buy over time.", "correct": true, "checked": false },
        { "answer": "b", "label": "It increases the interest rate on your savings automatically.", "correct": false, "checked": false },
        { "answer": "c", "label": "It makes your savings worth more.", "correct": false, "checked": false },
        { "answer": "d", "label": "It guarantees your savings will double.", "correct": false, "checked": false }
      ]
    }


]},

{topic: "Financial Decision-Making", questionList: [
    {
      "questionNbr": "FD-01",
      "questionText": "Why is setting financial goals important?",
      "answerType": "single",
      "notes": "Covers decision-making and goal-setting per Colorado PFL strand 1.",
      "answerList": [
        { "answer": "a", "label": "It helps you make clear plans for how to earn and spend your money.", "correct": true, "checked": false },
        { "answer": "b", "label": "It ensures you never make a mistake with your money.", "correct": false, "checked": false },
        { "answer": "c", "label": "It makes you wealthier automatically.", "correct": false, "checked": false },
        { "answer": "d", "label": "It allows you to ignore your budget.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-02",
      "questionText": "Which of the following is the best example of opportunity cost?",
      "answerType": "single",
      "notes": "Tests concept of opportunity cost.",
      "answerList": [
        { "answer": "a", "label": "Choosing to buy new shoes instead of saving for a concert ticket.", "correct": true, "checked": false },
        { "answer": "b", "label": "Saving and spending at the same time.", "correct": false, "checked": false },
        { "answer": "c", "label": "Getting paid every two weeks.", "correct": false, "checked": false },
        { "answer": "d", "label": "Buying something that is on sale.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-03",
      "questionText": "You are deciding between two part-time jobs — one pays more but offers fewer hours, the other pays less but offers steady hours. What should you consider most?",
      "answerType": "multiple",
      "notes": "Encourages weighing trade-offs and consistency in income.",
      "answerList": [
        { "answer": "a", "label": "How the total monthly pay compares between the two jobs.", "correct": true, "checked": false },
        { "answer": "b", "label": "How the job fits with your school schedule.", "correct": true, "checked": false },
        { "answer": "c", "label": "Which job your friends like more.", "correct": false, "checked": false },
        { "answer": "d", "label": "Whether either job offers vacation time right away.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-04",
      "questionText": "A short-term financial goal is best described as one you can achieve:",
      "answerType": "single",
      "notes": "Distinguishes short- vs long-term goals.",
      "answerList": [
        { "answer": "a", "label": "Within the next few months to a year.", "correct": true, "checked": false },
        { "answer": "b", "label": "Only after retirement.", "correct": false, "checked": false },
        { "answer": "c", "label": "Within 10 to 20 years.", "correct": false, "checked": false },
        { "answer": "d", "label": "When you receive an inheritance.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-05",
      "questionText": "When comparing two similar products, what is the most financially smart step to take before buying?",
      "answerType": "single",
      "notes": "Promotes comparison shopping and informed decisions.",
      "answerList": [
        { "answer": "a", "label": "Compare the prices and read customer reviews.", "correct": true, "checked": false },
        { "answer": "b", "label": "Buy the brand your friend recommends.", "correct": false, "checked": false },
        { "answer": "c", "label": "Choose the one with the flashiest packaging.", "correct": false, "checked": false },
        { "answer": "d", "label": "Pick whichever one is closest to the checkout.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-06",
      "questionText": "If you decide to buy a used car instead of a new one, what is your opportunity cost?",
      "answerType": "single",
      "notes": "Adds nuanced scenario to opportunity cost concept.",
      "answerList": [
        { "answer": "a", "label": "The benefits you give up by not buying the new car, like warranty " + 
          "or new features.", "correct": true, "checked": false },
        { "answer": "b", "label": "The gas you’ll buy for the used car.", "correct": false, "checked": false },
        { "answer": "c", "label": "The price you paid for the used car.", "correct": false, "checked": false },
        { "answer": "d", "label": "Your monthly insurance payment.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-07",
      "questionText": "Before making a large purchase, which question would help you make the most" +
          "responsible financial decision?",
      "answerType": "multiple",
      "notes": "Promotes self-assessment and budgeting logic.",
      "answerList": [
        { "answer": "a", "label": "Do I really need this item, or do I just want it right now?", 
          "correct": true, "checked": false },
        { "answer": "b", "label": "Can I afford it without using high-interest debt?", 
          "correct": true, "checked": false },
        { "answer": "c", "label": "Will buying this impress my friends?", "correct": false, 
          "checked": false },
        { "answer": "d", "label": "Does the store have cool music playing?", "correct": false,
          "checked": false }
      ]
    },
    {
      "questionNbr": "FD-08",
      "questionText": "When deciding whether to buy or lease a car, what’s a key financial factor to compare?",
      "answerType": "multiple",
      "answerList": [
        { "answer": "a", "label": "The total long-term cost, including monthly payments and fees.", "correct": true, "checked": false },
        { "answer": "b", "label": "How soon you can trade in or sell the car.", "correct": true, "checked": false },
        { "answer": "c", "label": "The color choices available.", "correct": false, "checked": false },
        { "answer": "d", "label": "Which option your friends prefer.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-09",
      "questionText": "Which statement about a mortgage is accurate?",
      "answerType": "single",
      "answerList": [
        { "answer": "a", "label": "It is a long-term loan used to buy a home.", "correct": true, "checked": false },
        { "answer": "b", "label": "It is the same as paying rent to a landlord.", "correct": false, "checked": false },
        { "answer": "c", "label": "It never requires paying interest.", "correct": false, "checked": false },
        { "answer": "d", "label": "It must be paid off within one year.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "FD-10",
      "questionText": "Which is a possible advantage of renting rather than buying a home?",
      "answerType": "single",
      "answerList": [
        { "answer": "a", "label": "Renters usually have fewer maintenance costs and more flexibility to move.", "correct": true, "checked": false },
        { "answer": "b", "label": "Renters always build equity in the property.", "correct": false, "checked": false },
        { "answer": "c", "label": "Renting always costs less than owning.", "correct": false, "checked": false },
        { "answer": "d", "label": "Renters can sell the property for profit.", "correct": false, "checked": false }
      ]
    }


  ],
},
  {topic: "Risk Management & Insurance", questionList: [
    {
      "questionNbr": "RI-01",
      "questionText": "What is the main purpose of insurance?",
      "answerType": "single",
      "notes": "Introduces concept of risk-sharing and protection.",
      "answerList": [
        { "answer": "a", "label": "To protect against financial loss from unexpected events.", "correct": true, "checked": false },
        { "answer": "b", "label": "To make more money quickly.", "correct": false, "checked": false },
        { "answer": "c", "label": "To guarantee that no accidents will happen.", "correct": false, "checked": false },
        { "answer": "d", "label": "To avoid paying for routine expenses.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "RI-02",
      "questionText": "Which of these situations is a good example of using an emergency fund?",
      "answerType": "single",
      "notes": "Tests understanding of emergency fund purpose.",
      "answerList": [
        { "answer": "a", "label": "Paying for unexpected car repairs.", "correct": true, "checked": false },
        { "answer": "b", "label": "Buying a new phone you want.", "correct": false, "checked": false },
        { "answer": "c", "label": "Paying for a concert ticket.", "correct": false, "checked": false },
        { "answer": "d", "label": "Buying birthday gifts for friends.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "RI-03",
      "questionText": "Which of the following types of insurance would cover damage to your car if you caused an accident?",
      "answerType": "single",
      "notes": "Applies real-life auto insurance example.",
      "answerList": [
        { "answer": "a", "label": "Collision insurance.", "correct": true, "checked": false },
        { "answer": "b", "label": "Health insurance.", "correct": false, "checked": false },
        { "answer": "c", "label": "Life insurance.", "correct": false, "checked": false },
        { "answer": "d", "label": "Renter’s insurance.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "RI-04",
      "questionText": "Why might someone choose to buy renter’s insurance?",
      "answerType": "multiple",
      "notes": "Promotes understanding of protection from property loss.",
      "answerList": [
        { "answer": "a", "label": "To replace personal belongings if they are stolen or damaged.", "correct": true, "checked": false },
        { "answer": "b", "label": "Because it covers the entire building.", "correct": false, "checked": false },
        { "answer": "c", "label": "Because the landlord requires it.", "correct": true, "checked": false },
        { "answer": "d", "label": "Because it helps increase credit score.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "RI-05",
      "questionText": "Which of the following actions helps protect you from identity theft?",
      "answerType": "multiple",
      "notes": "Covers digital literacy and fraud prevention under risk management.",
      "answerList": [
        { "answer": "a", "label": "Using strong, unique passwords for your financial accounts.", "correct": true, "checked": false },
        { "answer": "b", "label": "Regularly checking your bank and credit card statements.", "correct": true, "checked": false },
        { "answer": "c", "label": "Sharing your Social Security number online.", "correct": false, "checked": false },
        { "answer": "d", "label": "Posting pictures of your ID on social media.", "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "RI-06",
      "questionText": "If you choose a higher deductible on your car insurance, what will " + 
        "likely happen to your premium?",
      "answerType": "single",
      "notes": "Tests understanding of insurance trade-offs.",
      "answerList": [
        { "answer": "a", "label": "Your monthly premium will be lower.", "correct": true, "checked": false },
        { "answer": "b", "label": "Your premium will increase.", "correct": false, "checked": false },
        { "answer": "c", "label": "Your deductible will be waived.", "correct": false, "checked": false },
        { "answer": "d", "label": "You won’t need to pay for repairs anymore.", 
          "correct": false, "checked": false }
      ]
    },
    {
      "questionNbr": "RI-07",
      "questionText": "Which of the following is the best reason to have health insurance?",
      "answerType": "single",
      "notes": "Applies personal finance to health cost risk management.",
      "answerList": [
        { "answer": "a", "label": "It helps protect you from high medical costs if you get sick or injured.", "correct": true, "checked": false },
        { "answer": "b", "label": "It guarantees that you will never need medical care.", 
          "correct": false, "checked": false },
        { "answer": "c", "label": "It allows you to skip emergency savings.", "correct": false, 
          "checked": false },
        { "answer": "d", "label": "It increases your credit score.", "correct": false, "checked": false }
      ]
    }

  ]
},
 {topic: "General Financial Literacy", questionList: [
    
  {"questionNbr": "GN-01", 
    "questionText": "Which of these is considered good financial literacy advice?", 
    "answerType": "multiple", "answerList": [
      {"checked": false, "answer": "a", "correct": false,
        "label": "The best investments are risky because they offer the highest return."
      },
      {"checked": false, "answer": "b", "correct": false,
        "label": "You can spend as much as you want each month as long as you don’t spend more " + 
          "than what you make."
      },
      {"checked": false, "answer": "c", "correct": true,
        "label": "If possible, save part of your income each month—even a small amount adds up over time."
      },
      {"checked": false, "answer": "d", "correct": true,
        "label": "It’s smart to track your spending so you understand where your money actually goes."
      }
    ]
  },

  {"questionNbr": "GN-02", 
    "questionText": "What does it mean to be financially literate?", 
    "answerType": "single", "answerList": [
      {"checked": false, "answer": "a", "correct": true,
        "label": "You can use knowledge of money, credit, and investing to make informed financial decisions."
      },
      {"checked": false, "answer": "b", "correct": false,
        "label": "You always make the most money possible."
      },
      {"checked": false, "answer": "c", "correct": false,
        "label": "You avoid using credit or loans at all costs."
      },
      {"checked": false, "answer": "d", "correct": false,
        "label": "You memorize financial terms even if you don’t apply them."
      }
    ]
  },

  {"questionNbr": "GN-03", 
    "questionText": "Why is financial planning important, even for teenagers?", 
    "answerType": "single", "answerList": [
      {"checked": false, "answer": "a", "correct": true,
        "label": "It helps you set goals for earning, saving, and spending money responsibly—starting early builds good habits."
      },
      {"checked": false, "answer": "b", "correct": false,
        "label": "It guarantees you’ll never have financial problems."
      },
      {"checked": false, "answer": "c", "correct": false,
        "label": "It prevents you from ever needing to borrow money."
      },
      {"checked": false, "answer": "d", "correct": false,
        "label": "It’s only useful once you have a full-time job or pay bills."
      }
    ]
  },

  {"questionNbr": "GN-04", 
    "questionText": "Which of the following best describes a realistic financial goal?", 
    "answerType": "single", "answerList": [
      {"checked": false, "answer": "a", "correct": false,
        "label": "Spending all your paycheck before the next one so you don’t miss out on fun."
      },
      {"checked": false, "answer": "b", "correct": true,
        "label": "Saving $1,000 for a car down payment within one year by setting aside part of each paycheck."
      },
      {"checked": false, "answer": "c", "correct": false,
        "label": "Earning a million dollars by age 20 without a plan."
      },
      {"checked": false, "answer": "d", "correct": false,
        "label": "Buying new clothes each month even if it uses up your savings."
      }
    ]
  },

  {"questionNbr": "GN-05", 
    "questionText": "Which of the following actions would most likely improve your financial literacy over time?", 
    "answerType": "multiple", "answerList": [
      {"checked": false, "answer": "a", "correct": true,
        "label": "Reading about topics like budgeting, saving, and investing, and applying what you learn to your own money decisions."
      },
      {"checked": false, "answer": "b", "correct": true,
        "label": "Asking trusted adults or financial professionals questions about money management."
      },
      {"checked": false, "answer": "c", "correct": false,
        "label": "Waiting until you earn a large income before learning about personal finance."
      },
      {"checked": false, "answer": "d", "correct": false,
        "label": "Relying on friends’ spending habits to guide your own financial choices."
      }
    ]
  },

 ]},
 

]
}
export default MoneyMgmtTestDataset;

